import { appstr } from "@coreapp/utils/appstr";
import { Button, ButtonProps } from "@theorgchartdev/storybook";
import { useToolbarButtonTooltip } from "./useToolbarButtonTooltip";
import { useTableInstanceContext } from "@/providers/PlanningTabularProvider";

interface ClonePositionProps extends ButtonProps {}

export const ClonePosition = (props: ClonePositionProps) => {
  const { selectedPositionsCount, isOnlyActivePositionsSelected } = useTableInstanceContext();

  const singlePositionSelected = selectedPositionsCount === 1;
  const onlyActivePositionsSelected = isOnlyActivePositionsSelected();

  const tooltipProps = useToolbarButtonTooltip("clone");

  const isDisabled = !(singlePositionSelected && onlyActivePositionsSelected);

  return (
    <Button
      {...props}
      disabled={isDisabled}
      iconProps={{
        name: "copy",
        title: "copy"
      }}
      modifier="secondary"
      tooltipProps={tooltipProps}
    >
      {appstr("Clone")}
    </Button>
  );
};
